import Vue from "vue";
export const SET_DATA = (state, { id, data }) => {
  state[id] = data;
};
export const setListDiscuss = (state, items) => {
  items.forEach(element => {
    element.replies = [];
  });
  state.listDiscuss = items.reverse();
};
export const setReplies = (state, {replies , id}) => {
  // console.log(state.listDiscuss)
  // state.listDiscuss[replie.index].replies = replie.replies;
  state.listDiscuss.forEach((f,i)=>{
    if(f.id === id){
      Vue.set(state.listDiscuss[i], 'replies', replies);
    }
  })
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/discusses/mutations.js